import { useQuery } from '@tanstack/react-query';

import { fetchDraftVenue } from 'apis/merchant-onboarding-service/api';

const useDraftVenue = (merchantId: string, draftVenueId: string) => {
  const { data, error } = useQuery(['merchant-onboarding-service/draft-venues', merchantId, draftVenueId], () =>
    fetchDraftVenue(merchantId, draftVenueId),
  );
  return { data, error };
};

export default useDraftVenue;
